import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import BunkeyApi from "../../api/BunkeyAPI";
import {
  uuidv4,
  sendNotification,
  sendNotificationModified,
  normalizeString,
  isVersionTag
} from "../../utils";
import {
  setSelectItem,
  setQtyFilesError,
  addFileNewVersionAsset,
  setIsUploadingVersion,
  updateFileProgressVersionAsset,
  setUploadObjectToFileVersionAsset,
  setErrorStateToFileVersionAsset,
  setSuccessStateToFileVersionAsset,
  emptyAssetVersion,
  setVersionTagsAssetVersion,
  setUploading,
  unsetUploading,
  doneUploadVersionAsset,
  cancelUploadVersion,
  resetUploadByError,
  setTagsAssetVersion,
  removeTagAssetVersion,
  setUsersOption,
  setMentionedUsers
} from "../../actions/ClientAction";
import queryString from "query-string";
import momentTZ from "moment-timezone";
import moment from "moment";
import AWS from "../../utils/aws-config.js";
import { Progress, Icon, Tooltip, Button, Select, Popconfirm } from "antd";
import {
  setSelectedItem,
  getUsersToMentionAll
} from "../../actions/CommentAction";
import { getLastUploads } from "../../actions/AssetsLastUploadAction";
import { getFavorites } from "../../actions/AssetsFavoritesAction";
import { getShared } from "../../actions/AssetsShareAction";
import { Row } from "antd";
import "./versionAsset2.css";

import TagV2 from "../tagV2/TagV2";
import UploadFile from "../../utils/UploadFile";
import fileExtension from "file-extension";

function Closebutton(props) {
  const { onClose } = props;
  return (
    <React.Fragment>
      <span className="close-editarchive" onClick={onClose}>
        <svg
          width="21"
          height="22"
          viewBox="0 0 21 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.75942 7.89313C6.91611 8.05062 7.12206 8.12896 7.32801 8.12896C7.53396 8.12896 7.73991 8.05062 7.8966 7.89313C8.21078 7.57895 8.21078 7.06932 7.8966 6.75514L1.46363 0.315711C1.14945 0.00153374 0.640631 0.00153374 0.326454 0.315711C0.0122759 0.629889 0.0122759 1.13952 0.326454 1.4537L6.75942 7.89313Z"
            fill="white"
          />
          <path
            d="M11.6823 10.5442L20.7644 1.45406C21.0785 1.13989 21.0785 0.630257 20.7644 0.316079C20.4502 0.00190138 19.9414 -0.137015 19.6272 0.17797L9.97733 9.69779H9.73827V9.97643L0.207944 19.6344C-0.106233 19.9485 -0.046467 20.4582 0.266903 20.7724C0.423588 20.9298 0.659423 21.0082 0.865375 21.0082C1.07133 21.0082 1.29182 20.9298 1.4485 20.7724L10.5378 11.683L19.6231 20.7732C19.7798 20.9307 19.9882 21.009 20.1934 21.009C20.3985 21.009 20.6061 20.9307 20.7628 20.7732C21.0769 20.459 21.0777 19.9494 20.7636 19.6352L11.6823 10.5442Z"
            fill="white"
          />
        </svg>
      </span>
    </React.Fragment>
  );
}

function UploadSvgIcon() {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.6057 3.67888C12.442 3.51516 12.2226 3.42773 11.9997 3.42773C11.8891 3.42773 11.7777 3.44831 11.6714 3.49288C11.3517 3.62488 11.1426 3.93859 11.1426 4.28488L11.1426 23.142C11.1426 23.6152 11.5266 23.9992 11.9997 23.9992C12.4729 23.9992 12.8569 23.6152 12.8569 23.142L12.8569 6.35402L19.108 12.6052C19.4431 12.9403 19.9849 12.9403 20.32 12.6052C20.6551 12.27 20.6551 11.7283 20.32 11.3932L12.6057 3.67888Z"
          fill="#0096D6"
        />
        <path
          d="M8.57276 6.85742C8.35333 6.85742 8.1339 6.94142 7.96676 7.10856L3.68104 11.3943C3.3459 11.7294 3.3459 12.272 3.68104 12.6063C4.01619 12.9406 4.5579 12.9414 4.89304 12.6054L9.17876 8.31971C9.5139 7.98457 9.5139 7.44285 9.17876 7.10771C9.01162 6.94142 8.79219 6.85742 8.57276 6.85742Z"
          fill="#0096D6"
        />
        <path
          d="M0.857143 7.71429C1.33114 7.71429 1.71429 7.33114 1.71429 6.85714L1.71429 1.71429L22.2857 1.71429V6.85714C22.2857 7.33114 22.6697 7.71429 23.1429 7.71429C23.616 7.71429 24 7.33114 24 6.85714V0.857143C24 0.383143 23.616 0 23.1429 0L0.857143 0C0.383143 0 0 0.383143 0 0.857143L0 6.85714C0 7.33114 0.383143 7.71429 0.857143 7.71429Z"
          fill="#0096D6"
        />
      </svg>
    </React.Fragment>
  );
}

function VersionTag2(props) {
  const { tag, removeTag } = props;
  const isTagSliced = tag && tag.length > 15;
  const slicedTag = isTagSliced ? tag.slice(0, 15) : tag;
  return (
    <React.Fragment>
      {!isTagSliced && (
        <button className="bb-modal__editv2-item">
          {tag}
          <span
            onClick={() => {
              removeTag(tag);
            }}
          >
            <svg
              width="9"
              height="9"
              viewBox="0 0 9 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.87732 3.36051C2.94401 3.42754 3.03166 3.46088 3.11932 3.46088C3.20698 3.46088 3.29463 3.42754 3.36132 3.36051C3.49504 3.22679 3.49504 3.00988 3.36132 2.87616L0.623352 0.135445C0.489633 0.00172657 0.27307 0.00172657 0.139352 0.135445C0.00563282 0.269164 0.00563282 0.48607 0.139352 0.619789L2.87732 3.36051Z"
                fill="#535361"
              />
              <path
                d="M4.97216 4.48778L8.83763 0.618872C8.97135 0.485153 8.97135 0.268247 8.83763 0.134528C8.70391 0.000809258 8.48735 -0.0583157 8.35363 0.0757468L4.2465 4.12753H4.14475V4.24612L0.0885042 8.35668C-0.0452146 8.4904 -0.0197771 8.70731 0.113598 8.84103C0.180285 8.90806 0.28066 8.9414 0.368317 8.9414C0.455973 8.9414 0.549817 8.90806 0.616504 8.84103L4.48507 4.97247L8.35191 8.84137C8.4186 8.9084 8.50729 8.94175 8.5946 8.94175C8.68191 8.94175 8.77025 8.9084 8.83694 8.84137C8.97066 8.70765 8.971 8.49075 8.83729 8.35703L4.97216 4.48778Z"
                fill="#535361"
              />
            </svg>
          </span>
        </button>
      )}
      {isTagSliced && (
        <Tooltip placement="top" title={tag}>
          <button className="bb-modal__editv2-item">
            {slicedTag + "..."}
            <span
              onClick={() => {
                removeTag(tag);
              }}
            >
              <svg
                width="9"
                height="9"
                viewBox="0 0 9 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.87732 3.36051C2.94401 3.42754 3.03166 3.46088 3.11932 3.46088C3.20698 3.46088 3.29463 3.42754 3.36132 3.36051C3.49504 3.22679 3.49504 3.00988 3.36132 2.87616L0.623352 0.135445C0.489633 0.00172657 0.27307 0.00172657 0.139352 0.135445C0.00563282 0.269164 0.00563282 0.48607 0.139352 0.619789L2.87732 3.36051Z"
                  fill="#535361"
                />
                <path
                  d="M4.97216 4.48778L8.83763 0.618872C8.97135 0.485153 8.97135 0.268247 8.83763 0.134528C8.70391 0.000809258 8.48735 -0.0583157 8.35363 0.0757468L4.2465 4.12753H4.14475V4.24612L0.0885042 8.35668C-0.0452146 8.4904 -0.0197771 8.70731 0.113598 8.84103C0.180285 8.90806 0.28066 8.9414 0.368317 8.9414C0.455973 8.9414 0.549817 8.90806 0.616504 8.84103L4.48507 4.97247L8.35191 8.84137C8.4186 8.9084 8.50729 8.94175 8.5946 8.94175C8.68191 8.94175 8.77025 8.9084 8.83694 8.84137C8.97066 8.70765 8.971 8.49075 8.83729 8.35703L4.97216 4.48778Z"
                  fill="#535361"
                />
              </svg>
            </span>
          </button>
        </Tooltip>
      )}
    </React.Fragment>
  );
}

class VersionAsset2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showWarningEmptyTags: false,
      showModal: false
    };
    this.uploadInputRef = React.createRef();

    AWS.config.setPromisesDependency();
    
  }

  componentDidMount() {
    const { isUploadingVersion, emptyAssetVersion, files } = this.props;
    if (files && files.length > 0 && !isUploadingVersion) {
      emptyAssetVersion();
    }
  }
  componentWillUnmount() {
    const { isUploadingVersion, emptyAssetVersion } = this.props;
    if (!isUploadingVersion) {
      emptyAssetVersion();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { itemSelected } = this.props;

    if (
      (prevProps.itemSelected.document === null &&
        this.props.itemSelected.document) ||
      (this.props.itemSelected.document &&
        this.props.itemSelected.document._id !==
          prevProps.itemSelected.document._id)
    ) {
      const { descriptiveTags } = itemSelected.document.metadata;
      this.handleGetTagNewVersion(this.props.itemSelected.document._id);

      const objectTags = {
        tags:
          descriptiveTags && Array.isArray(descriptiveTags)
            ? descriptiveTags
            : []
      };
      objectTags.tags = objectTags.tags.filter(tag => !isVersionTag(tag));
      this.props.setTagsAssetVersion(objectTags);
    }
  }

  handleUploadFiles = () => {
    const { clientId, user, clientName, files } = this.props;
    const {
      updateFileProgressVersionAsset,
      setUploadObjectToFileVersionAsset
    } = this.props;

    const inProgress = files.filter(r => r.state === "inprogress").length;
    const LIMIT = 3;

    if (inProgress === 0) {
      files
        .filter(r => r.state === "waiting")
        .slice(0, LIMIT)
        .forEach(file => {
          const uploadObject = new UploadFile(clientId, clientName, user);
          uploadObject
            .checkIsSetAccelerateConfiguration()
            .then(() => {
              uploadObject.startUpload(
                file,
                setUploadObjectToFileVersionAsset,
                updateFileProgressVersionAsset,
                this.handleSaveRecord,
                null,
                this.handleUploadError
              );
            })
            .catch(error => {
              console.error("error catch ", error);
            });
        }); //fin foreach
    }
  };
  startUpload = async (err, data) => {
    if (err) return;
    const upload = new AWS.S3.ManagedUpload({
      params: {
        Bucket: data.bucket,
        Key: data.fileKey,
        Body: data.file.file
      },
      partSize: 5 * 1024 * 1024,
      queueSize: 1,
      tags: [
        { Key: "Content-Disposition", Value: "attachment" },
        { Key: "Content-Type", Value: data.file.type },
        { Key: "x-amz-meta-uuid", Value: data.file.uuid },
        { Key: "ext", Value: data.file.ext },
        { Key: "size", Value: data.file.size },
        { Key: "name", Value: normalizeString(data.file.name) },
        { Key: "user-name", Value: normalizeString(data.user.name) },
        { Key: "client-name", Value: normalizeString(data.clientName) },
        { Key: "applyRkg", Value: data.file.applyRkg }
      ]
    });
    this.props.setUploadObjectToFileVersionAsset(data, upload);
    upload
      .on("httpUploadProgress", e => {
        //REDUX
        this.props.updateFileProgressVersionAsset(e, data);
      })
      .promise()
      .then(
        respUpload => {
          const s3 = new AWS.S3();
          s3.putObjectAcl(
            {
              Bucket: data.bucket,
              Key: respUpload.Key,
              ACL: "public-read"
            },
            (err, respAcl) => {
              if (err) console.log(err, err.stack);
              else {
                this.handleSaveRecord({
                  ...data.file,
                  key: respUpload.Key,
                  futureFileURL: respUpload.Location
                });
              }
            }
          );
        },
        err => {
          if (err.code !== "RequestAbortedError") {
            this.props.resetUploadByError();
            sendNotification(
              "error",
              this.props.intl,
              this.props.intl.formatMessage({ id: "failed_upload_version" })
            );
          }
        }
      );
  };

  handleUploadError = () => {
    this.props.resetUploadByError();
    sendNotification(
      "error",
      this.props.intl,
      this.props.intl.formatMessage({ id: "failed_upload_version" })
    );
  };

  handleSaveRecord = asset => {
    const {
      user,
      itemSelected,
      mentionedUsers,
      intl,
      keyCollection,
      from,
      location,
      workclient,
      searchText,
      searchType,
      orderBy,
      root
    } = this.props;
    let typeFile,
      fileName,
      nameFile,
      assetName,
      arrAssetType = "";

    fileName = asset.name.split(".");
    fileName.pop();
    nameFile = fileName.join(".");
    assetName = asset.name.length > 10 ? asset.name.slice(0, 10) : asset.name;

    if (!asset.type) {
      typeFile = "document";
    } else {
      arrAssetType = asset.type.split("/");
      if (arrAssetType[0] !== "image" && arrAssetType[0] !== "video") {
        typeFile = "document";
      } else {
        typeFile = arrAssetType[0];
      }
    }

    const copyright = {
      createDate: moment().format("YYYY-MM-DD"),
      dueDate: null
    };

    const metaData2 = {
      copyright,
      // tags: [...itemSelected.document.metadata.descriptiveTags, ...this.props.versionTags]
      tags: [...this.props.tags, ...this.props.versionTags]
    };
    BunkeyApi({
      url: `assetVersion`,
      method: "POST",
      data: {
        documentId: itemSelected.document._id,
        isFinal: false,
        description: "",
        userId: user._id,
        mentionatedUsers: mentionedUsers ? mentionedUsers : [],
        document: {
          metadata: {
            descriptiveTags: metaData2.tags,
            copyRight: "free",
            type: "final",
            createdDate: metaData2.copyright.createDate, //metadata.copyright.createDate,
            dueDate: metaData2.copyright.dueDate //metadata.copyright.dueDate
          },
          name: nameFile,
          fileSize: asset.size,
          fileSizeFormat: asset.sizeFormat,
          uuid: asset.uuid,
          type: typeFile,
          url: asset.futureFileURL
        }
      }
    })
      .then(resp => {
        this.props.setSuccessStateToFileVersionAsset(asset).then(response => {
          sendNotification(
            "success",
            intl,
            `${intl.formatMessage({
              id: "the_asset"
            })} ${assetName} ${intl.formatMessage({
              id: "uploaded_successfully"
            })}`,
            4,
            "topRight"
          );

          const isPdfFile =
            fileExtension(asset.futureFileURL).toLocaleLowerCase() === "pdf";
          if (isPdfFile) {
            sendNotification(
              "success",
              intl,
              intl.formatMessage(
                { id: "file_sent_to_convertinator" },
                { fileName: nameFile + ".pdf" }
              ),
              null,
              "topRight"
            );
          }
          const searchService = {
            searchText,
            searchType,
            page: 1,
            orderBy,
            location
          };
          this.props.doneUploadVersionAsset(
            itemSelected,
            workclient,
            root,
            keyCollection,
            from,
            searchService
          );
        });
      })
      .catch(err => {
        console.log("error post handleSaveRecord: ", err);
      });
  };

  handleVerifyBeforeCreate = (clientId, data) => {
    const { intl, breadcrumb } = this.props;
    const path = `clients/${clientId}/objects/verifyBeforeCreate?${queryString.stringify(
      data
    )}`;
    BunkeyApi({
      url: path,
      method: "GET",
      data
    })
      .then(resp => {
        if (resp.status === 200 && resp.data.length > 0) {
          let build = [];
          resp.data.forEach(i => {
            let bread = "";
            let id = "";
            this.handleBreadcrumbs(i, breadcrumb).forEach(r => {
              bread += `${r.name}/`;
              id = r.id;
            });
            build.push({ name: bread, key: id });
          });
          sendNotificationModified(
            intl,
            intl
              .formatMessage({ id: "there_are_already_files_with_this_name" })
              .replace("#name", data.name),
            build
          );
        }
      })
      .catch(err => {
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "the_asset_could_not_be_verified" })
        );
      });
  };

  handleGetTagNewVersion = documentId => {
    const { intl } = this.props;
    const tz = momentTZ.tz.guess();
    const tzB64 = window.btoa(tz);
    const {
      itemSelected,
      setVersionTagsAssetVersion,
      operatorsUsersToComment,
      adminUsersToComment
    } = this.props;

    BunkeyApi({
      url: `assetVersion/prepareVersion/${documentId}/tz/${tzB64}?d=${itemSelected}`,
      method: "GET"
    })
      .then(resp => {
        if (adminUsersToComment || operatorsUsersToComment) {
          let data = [
            ...(adminUsersToComment ? adminUsersToComment : []),
            ...(operatorsUsersToComment ? operatorsUsersToComment : [])
          ];
          data = [
            ...data.sort((a, b) =>
              a.email.toLowerCase() < b.email.toLowerCase()
                ? -1
                : a.email.toLowerCase() > b.email.toLowerCase()
                ? 1
                : 0
            )
          ];
          this.props.setUsersOption(data);
        }

        setVersionTagsAssetVersion(resp.data);
      })
      .catch(e => {
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "error_getting_version_tags" })
        );
      });
  };

  /**
   * @param { Object } itemSelected
   * @name handleGetUsers
   */
  handleGetUsers = itemSelected => {
    let users = [];

    if (itemSelected && itemSelected.adminUsers) {
      itemSelected.adminUsers.forEach(item => {
        users.push({
          _id: item._id,
          name: item.name,
          email: item.email
        });
      });
    }

    if (itemSelected && itemSelected.operatorUsers) {
      itemSelected.operatorUsers.forEach(item => {
        if (!users.find(r => r._id === item.id)) {
          users.push({
            _id: item._id,
            name: item.name,
            email: item.email
          });
        }
      });
    }
    return users;
  };
  handleBreadcrumbs = (item, breadcrumb) => {
    let route = [];
    item.parents.forEach(itemParents => {
      breadcrumb.forEach(breadElement => {
        if (itemParents === breadElement._id)
          route.push({ id: breadElement._id, name: breadElement.name });
      });
    });
    return route;
  };

  handleFormat = size => {
    const i = Math.floor(Math.log(size) / Math.log(1024));
    return (
      (size / Math.pow(1024, i)).toFixed(2) * 1 +
      " " +
      ["B", "kB", "MB", "GB", "TB"][i]
    );
  };

  handleOnChange = e => {
    const { length } = e.target.files;
    const { clientId, intl, addFileNewVersionAsset, files, tags } = this.props;
    e.persist();

    for (let i = 0; i < length; i++) {
      const exists = files.find(
        r =>
          r.name === e.target.files[i].name && r.size === e.target.files[i].size
      );
      if (!exists) {
        const filterName = e.target.files[i].name.substring(
          0,
          e.target.files[i].name.lastIndexOf(".")
        );
        this.handleVerifyBeforeCreate(clientId, { name: filterName });
        const ext = e.target.files[i].name.split(".").slice(-1);
        const uuid = uuidv4();
        const s3Name = `${uuid}.${ext}`;
        const newFile = {
          uuid,
          s3Name,
          ext,
          applyRkg: true,
          uploadObject: null,
          file: e.target.files[i],
          name: e.target.files[i].name,
          size: e.target.files[i].size,
          sizeFormat: this.handleFormat(e.target.files[i].size),
          type: e.target.files[i].type,
          state: "waiting",
          progress: 0
        };
        let reader = new FileReader();
        reader.readAsArrayBuffer(e.target.files[i]);
        reader.onloadend = file => {
          if (file.total === 0) {
            sendNotification(
              "error",
              intl,
              intl.formatMessage({ id: "could_not_add_folder" })
            );
          } else {
            addFileNewVersionAsset(newFile);
          }
        };
      }
    }
    this.uploadInputRef.current.value = "";
    this.setState({
      showModal: true,
      showWarningEmptyTags: tags && tags.length === 0
    });
    this.props.handleShowNewVersionAsset();
  };

  handleCloseModal = () => {
    const { isUploadingVersion, emptyAssetVersion } = this.props;
    if (!isUploadingVersion) {
      emptyAssetVersion();
    }
    this.setState({ showModal: false });
  };

  handleStartUploading = () => {
    const { tags } = this.props;

    if (tags && tags.length > 0) {
      this.setState(
        {
          showWarningEmptyTags: false
        },
        () => {
          this.props.setIsUploadingVersion();
          this.handleUploadFiles();
        }
      );
    } else {
      this.setState({
        showWarningEmptyTags: true
      });
    }
  };

  handleOnClick = () => {
    const { isUploadingVersion } = this.props;

    if (!isUploadingVersion) {
      this.uploadInputRef.current.click();
    } else {
      this.setState({ showModal: true });
    }
  };

  handleOnChangeUser = (item, list) => {
    const mentionedUsers = list.map(r => {
      return { _id: r.props.uid, email: r.props.email, name: r.props.name };
    });
    this.props.setMentionedUsers(mentionedUsers);
  };
  render() {
    const { showModal, showWarningEmptyTags } = this.state;
    const {
      files,
      versionTags,
      isUploadingVersion,
      intl,
      tags,
      removeTagAssetVersion,
      //   usersOption,
      user,
      mentionedUsers,
      adminUsersToComment,
      operatorsUsersToComment,
      usersAll
    } = this.props;
    const fileToUpload = files.length > 0 ? files[0] : {};
    const tagList2 = tags.map((tag, index) => (
      <VersionTag2
        tag={tag}
        key={`2-${tag}-${index}`}
        removeTag={removeTagAssetVersion}
      />
    ));
    const versionTagsLi = versionTags.map((tag, index) => (
      <li key={`li-tag-${index}`}>{tag}</li>
    ));

    /** USUARIOS PARA NOTIFICAR */

    let listUsersNotified = [
      ...adminUsersToComment,
      ...operatorsUsersToComment
    ];

    //Añadimos los usuarios admin si aplica
    const isPartOfTheGroup =
      listUsersNotified.find(u => u.email === user.email) ||
      (user && user.clientRole === "admin" && user.role === "admin");

    if (isPartOfTheGroup) {
      for (let useradmin of usersAll) {
        let temp = listUsersNotified.find(u => u.email === useradmin.email);
        if (!temp)
          listUsersNotified.push({
            id: useradmin._id,
            name: useradmin.name,
            email: useradmin.email
          });
      }
    }

    //Ordenamos
    listUsersNotified = [
      ...listUsersNotified.sort((a, b) =>
        a.email.toLowerCase() < b.email.toLowerCase()
          ? -1
          : a.email.toLowerCase() > b.email.toLowerCase()
          ? 1
          : 0
      )
    ].filter(r => r.id !== user._id);

    const notifiedSelectOptions = listUsersNotified //usersOption
      .filter(r => r._id !== user._id)
      .map((r, k) => (
        <Select.Option
          key={k}
          name={r.name}
          email={r.email}
          value={`${r.name} (${r.email})`}
          uid={r._id}
        >
          {" "}
          {`${r.name} (${r.email})`}
        </Select.Option>
      ));

    const mentionedUsersValue = mentionedUsers.map(
      mentionedUser => `${mentionedUser.name} (${mentionedUser.email})`
    );

    return (
      <React.Fragment>
        <div onClick={this.handleOnClick} className="uploadButtonVersionAsset">
          <UploadSvgIcon />
          <span>{intl.formatMessage({ id: "upload_new_version" })}</span>
          <input type="button" />
        </div>

        <input
          type="file"
          ref={this.uploadInputRef}
          multiple={false}
          onChange={this.handleOnChange}
          hidden
        />

        {/* <div className="bb-modal editarchivev2"> */}
        {showModal && fileToUpload.name && (
          <div className={`bb-modal  ${showModal ? "editarchivev2" : ""} `}>
            <div className="bb-modal__editv2">
              <Closebutton onClose={this.handleCloseModal} />
              <div className="bb-modal__editv2-top">
                <h3>{fileToUpload.name}</h3>
              </div>
              <div className="bb-modal__editv2-data">
                <ul>
                  {versionTagsLi}
                  <li className="loader">
                    {Math.trunc(fileToUpload.progress)}%{" "}
                    {intl.formatMessage({ id: "upload_progress_message" })}
                    <div className="version-upload-progress ">
                      {/* <span style={{ width: "50%" }}>
                                        </span> */}
                      <div className="progress-wrapper">
                        <Progress
                          percent={fileToUpload.progress}
                          size="small"
                          status={
                            fileToUpload.state === "inprogress"
                              ? "active"
                              : fileToUpload.state === "error"
                              ? "exception"
                              : "success"
                          }
                          strokeWidth={6}
                          showInfo={false}
                        />
                      </div>
                    </div>
                    {fileToUpload.state === "inprogress" && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          paddingLeft: "3px",
                          alignItems: "center"
                        }}
                      >
                        <Tooltip
                          placement="top"
                          title={intl.formatMessage({ id: "cancel_upload" })}
                        >
                          <Icon
                            type="close-circle"
                            style={{
                              fontSize: "15px",
                              color: "red",
                              marginLeft: "15px"
                            }}
                            onClick={() => {
                              this.props.cancelUploadVersion(fileToUpload);
                            }}
                          />
                        </Tooltip>
                      </div>
                    )}
                  </li>
                </ul>
              </div>
              <div className="bb-modal__editv2-tags">
                <h3 style={{ fontWeight: "bold" }}>
                  {intl.formatMessage({ id: "enherited_tag" })}
                </h3>
                <div className="bb-modal__editv2-items">{tagList2}</div>
              </div>
              <div className="bb-modal__editv2-actions">
                <div className="bb-modal__editv2-input">
                  <TagV2
                    handleTags={this.props.setTagsAssetVersion}
                    fillTags={this.props.tags}
                    hideTags={true}
                  />
                </div>
              </div>
              <div className="bb-modal__editv2-users">
                <h3>{intl.formatMessage({ id: "notify_users" })}</h3>
                <div
                  className="bb-modal__editv2-input"
                  style={{ display: "none" }}
                >
                  {/* <input type="text" placeholder="Agregar Usuarios" /> */}
                </div>
                <Row className="version-upload-select">
                  <Select
                    mode="multiple"
                    style={{ width: "100%" }}
                    value={mentionedUsersValue}
                    onChange={this.handleOnChangeUser}
                  >
                    {notifiedSelectOptions}
                  </Select>
                </Row>
              </div>

              {!showWarningEmptyTags && (
                <Button
                  className="bb-modal__editv2-save"
                  style={{ height: "52px", borderRadius: "0" }}
                  loading={isUploadingVersion}
                  onClick={this.handleStartUploading}
                  disabled={isUploadingVersion}
                >
                  {intl.formatMessage({ id: "upload_button" })}
                </Button>
              )}

              {showWarningEmptyTags && (
                <Popconfirm
                  title={intl.formatMessage({ id: "tags_confirm_empty_tags" })}
                  onConfirm={() => {
                    this.setState(
                      {
                        showWarningEmptyTags: false
                      },
                      () => {
                        this.props.setIsUploadingVersion();
                        this.handleUploadFiles();
                      }
                    );
                  }}
                  okText={intl.formatMessage({
                    id: "tags_upload_without_tags"
                  })}
                  cancelText={intl.formatMessage({
                    id: "tags_upload_add_tags"
                  })}
                >
                  <Button
                    className="bb-modal__editv2-save"
                    style={{ height: "52px", borderRadius: "0" }}
                    loading={isUploadingVersion}
                    onClick={this.handleStartUploading}
                    disabled={isUploadingVersion}
                  >
                    {intl.formatMessage({ id: "upload_button" })}
                  </Button>
                </Popconfirm>
              )}
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    token: state.authUser.token.accessToken,
    clientId: state.client.data ? state.client.data._id : null,
    clientName: state.client.data ? state.client.data.name : "",
    user: state.authUser.user,
    workclient: state.client.workclient,
    searchText: state.searcher.searchText,
    searchType: state.searcher.searchType,
    orderBy: state.searcher.orderBy,
    breadcrumb: state.client.breadcrumb,
    qtyFilesError: state.client.qtyFilesError,
    attemps: state.client.attemps,
    numberAttemps: state.client.numberAttemps,
    folderselect: state.assetsExplore.folderselect,
    root: state.client.root,
    itemsCommentSelected: state.comments.itemSelected,
    isUploading: state.client.isUploading,
    isUploadingVersion: state.client.uploadVersionAsset.isUploadingVersion,
    files: state.client.uploadVersionAsset.files,
    itemSelected: state.client.uploadVersionAsset.itemSelected,
    versionTags: state.client.uploadVersionAsset.versionTags,
    tags: state.client.uploadVersionAsset.tags,
    usersOption: state.client.uploadVersionAsset.usersOption,
    mentionedUsers: state.client.uploadVersionAsset.mentionedUsers,

    //Users
    adminUsersToComment: state.comments.adminUsersToComment,
    operatorsUsersToComment: state.comments.operatorsUsersToComment,
    usersAll:
      state.users && state.users.data
        ? state.users.data.filter(
            u =>
              u.email.indexOf("@bunkey.tv") === -1 && u.clientRole === "admin"
          )
        : []
  };
};
const mapDispatchToProps = {
  setIsUploadingVersion,
  addFileNewVersionAsset,
  emptyAssetVersion,
  setVersionTagsAssetVersion,
  setQtyFilesError,
  setErrorStateToFileVersionAsset,
  setSuccessStateToFileVersionAsset,
  updateFileProgressVersionAsset,
  setUploadObjectToFileVersionAsset,
  setSelectItem,
  setUploading,
  unsetUploading,
  setSelectedItem,
  getLastUploads,
  getFavorites,
  getShared,
  doneUploadVersionAsset,
  cancelUploadVersion,
  resetUploadByError,
  setTagsAssetVersion,
  removeTagAssetVersion,
  setUsersOption,
  setMentionedUsers,
  getUsersToMentionAll
};
export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(VersionAsset2))
);
